import React from 'react';
import { injectIntl } from 'react-intl';
import c3 from 'c3';
import { isEqual, cloneDeep } from 'lodash';

import { GRAPHS_COLOR_SCHEME } from './../../../constants';

class C3Chart extends React.PureComponent {

    constructor(props) {
        super(props);

        this.adaptConfigForChart = this.adaptConfigForChart.bind(this);
        this.drawChart = this.drawChart.bind(this);

        this.checkRequiredFields(this.props);

        // Tweak for the C3 isWithinBar() internal method
        c3.chart.internal.fn.isWithinBar = this.isWithinBarTweak;
    }

    componentWillReceiveProps(nextProps) {
        this.checkRequiredFields(nextProps);
    }

    componentDidMount() {
        this.drawChart();
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.config, this.props.config)) {
            this.drawChart();
        }
    }

    /**
     * This is a tweak of the C3 isWithinBar() internal method to be able to
     * solve issue {@link https://jira.moreover.com/browse/RMM-1535|RMM-1535}.
     * The problem is that when hovering a bar, it gets active using mathematical
     * calculus of mouse being inside certain coordinates. But, the "offset"
     * parameter has the default value to 2 which causes incorrect bar selections.
     *
     * This is a known issue: {@link https://github.com/c3js/c3/issues/1658}!!!
     *
     * Source: {@link http://stackoverflow.com/questions/38846168/c3js-bar-chart-onclick-event-getting-triggered-twice#38850256}
     *
     * @param   {Object}  that   The bar segment being selected.
     * @return  {boolean}        True or false depending if the mouse is over the bar segment.
     */
    isWithinBarTweak(that) {
        var mouse = this.d3.mouse(that), box = that.getBoundingClientRect(),
            seg0 = that.pathSegList.getItem(0), seg1 = that.pathSegList.getItem(1),
            x = Math.min(seg0.x, seg1.x), y = Math.min(seg0.y, seg1.y),
            w = box.width, h = box.height, offset = 0, // The "offset" parameter was initially 2
            sx = x - offset, ex = x + w + offset, sy = y + h + offset, ey = y - offset;
        return sx < mouse[0] && mouse[0] < ex && ey < mouse[1] && mouse[1] < sy;
    }

    checkRequiredFields(props) {
        if (!props.config) {
            throw new TypeError('The "config" parameter is mandatory!');
        }
        if (!props.config.bindto) {
            throw new TypeError('The "config.bindto" parameter is mandatory!');
        }
    }

    adaptConfigForChart(config) {
        if (!config.data ||
            ((!config.data.columns || config.data.columns.length === 0) &&
            (!config.data.rows || config.data.rows.length < 2))) {

            // Only add the no rows configuration if data is really empty, thus preventing the
            // flicker between the "empty chart" message and the chart data displaying
            config.data = {
                rows: [],
                empty: {
                    label: {
                        text: this.props.intl.formatMessage({id: 'Dashboard_Dashboard_CoreFunctionality_Error__Error_chart.noData'})
                    }
                }
            };
        }

        config.color = {pattern: GRAPHS_COLOR_SCHEME};
    }

    drawChart() {
        let config = cloneDeep(this.props.config);
        this.adaptConfigForChart(config);
        c3.generate(config);
    }

    render() {
        return (<div className="notranslate" id={this.props.config.bindto.substr(1)}></div>);
    }

}

export default injectIntl(C3Chart);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Charts/C3Chart/C3Chart.jsx